var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.page)?_c('div',[_c('page-banner',{attrs:{"title":_vm.page.banner.title,"text":_vm.page.banner.text,"colour":_vm.page.banner.colour}}),_vm._v(" "),_c('page-cards',{attrs:{"pages":_vm.homePageCards}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }